<div
  class="form-group"
  [formGroup]="formGroup!"
>
  <label
    for="{{ config?.name }}"
    class="mb-1 fw-bold"
  >
    {{ config?.label }}
    @if (config ? showAsterisk(config) : false) {
      *
    }
  </label>

  <ngb-timepicker
    [id]="config?.name"
    [formControlName]="config?.name ?? null"
  />

  <div
    libFormFieldError
    [fieldConfig]="config!"
    [formComponent]="fc"
  ></div>
</div>
